import * as React from 'react';

import { useClickTracker } from '@shared-ui/clickstream-analytics-context';
import { useDialog } from '@shared-ui/dialog-context';
import { useLocalization } from '@shared-ui/localization-context';

import { MarketingFeeDetails } from 'src/common/models';

import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkMark, UitkMarkSize } from 'uitk-react-mark';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface MarketingFeeDetailsContainerProps {
  marketingFeeDetails?: MarketingFeeDetails;
  hotelId?: number;
}

export const MarketingFeeDetailsContainer: React.FunctionComponent<MarketingFeeDetailsContainerProps> = ({
  marketingFeeDetails,
  hotelId,
}) => {
  const marketingFeeDialogId = hotelId ? `priceMarketingFeeDialog-${hotelId}` : 'priceMarketingFeeDialog';

  const [, dialogActions, DialogComponent] = useDialog(marketingFeeDialogId, 'pwaDialog');
  const track = useClickTracker();
  const l10n = useLocalization();
  const openDialog = () => {
    track('TAAP.MarketingFee.Details', 'Open SRP Commission Information Dialog');
    dialogActions.openDialog();
  };

  if (!marketingFeeDetails?.tierName) {
    return null;
  }

  return (
    <div data-stid="marketing-fee-info">
      <UitkLayoutFlex direction="column">
        <UitkLayoutFlexItem alignSelf="end">
          <UitkSpacing padding={{ blockstart: 'two' }}>
            <UitkMoreInfoTrigger onClick={openDialog}>
              <button>
                <UitkSpacing padding={{ inlineend: 'one' }}>
                  <UitkMark name={marketingFeeDetails.tierIcon} size={UitkMarkSize.SMALL} />
                </UitkSpacing>
                <UitkText overflow="truncate" theme="default" inline>
                  {marketingFeeDetails.tierName}
                </UitkText>
                <UitkIcon name="info_outline" theme="secondary" size={UitkIconSize.SMALL} />
              </button>
            </UitkMoreInfoTrigger>
          </UitkSpacing>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
      <DialogComponent>
        <UitkDialog returnFocusOnClose>
          <UitkDialogContent>
            <UitkText>{marketingFeeDetails.marketingFeeMessage.value}</UitkText>
          </UitkDialogContent>
          <UitkDialogFooter
            buttonOne={{
              onClick: dialogActions.closeDialog,
              text: l10n.formatText('close'),
              type: 'tertiary',
            }}
          />
        </UitkDialog>
      </DialogComponent>
    </div>
  );
};
